import React, {useContext, useEffect, useState} from 'react';
//imports
import '../../styles/NavBar.css';
import {useNavigate} from "react-router-dom";
import {AuthContext} from "../../config/AuthContext";
import {Menu} from "antd";
import {BsHouse, BsPerson, BsPower, BsToggleOff} from "react-icons/bs";
import Colors from "../../styles/Colors";
import {defaultMenu} from "../../model/root/Menu";

const NavBar = () => {
    const navigate = useNavigate();
    const {isLoggedIn, userId, user, actualSite, setActualSite} = useContext(AuthContext);
    const [current, setCurrent] = useState('mail');
    const [currentMenu, setCurrentMenu] = useState([]);



    const homeItem = {
        key: 'home',
        label: '',
        icon: <BsHouse />
    };

    const logoutItem = {
        key: '',
        label: '',
        icon: <BsPower />
    };

    const profileItem = {
        key: `profile/${userId}`,
        label: '',
        icon: <BsPerson />
    };


    useEffect(() => {
        user.menus && user.menus.map(value => (
            value && value.menu && value.pantalla &&
            value.pantalla === actualSite && setCurrentMenu(value.menu)
        ));

    }, []);

    const isItemInArrayHome = user.menus.some((value) =>
        value.menu && value.pantalla === actualSite && value.menu.some((item) => item.key === homeItem.key)
    );

    if (!isItemInArrayHome) {
        currentMenu.push(homeItem);
        currentMenu.push(logoutItem);
        currentMenu.push(profileItem);
    }

    const onClick = (e) => {
        console.log('click ', e);
        //setCurrent(e.key);
        if (e.key === 'home' || e.key === '')
            setActualSite("root");
        navigate("/" + e.key);
    };

    return(
    <div className="navbar-wrapper">
        {/* Menú de texto a la izquierda */}
        <Menu
        className="menu-left"
        style={{backgroundColor: Colors.colors.color2, color: Colors.colors.color6}}
        mode="horizontal"
        onClick={onClick}
        selectedKeys={[current]}
        items={currentMenu.filter(item => item.icon === undefined)}
        />

        {/* Menú de iconos a la derecha */}
        <Menu
        className="menu-right"
        style={{backgroundColor: Colors.colors.color2, color: Colors.colors.color6}}
        mode="horizontal"
        onClick={onClick}
        selectedKeys={[current]}
        items={currentMenu.filter(item => item.icon !== undefined)}
        />
    </div>
    );
};

export default NavBar;
